import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';

const ImageToDisplay = ({selectedImage, setSelectedImage,setErrors = ()=>{} }) => {
  const [image, setImage] = useState(null);  

  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];
  //   setSelectedImage(file)
    
  //   setErrors(preval =>{return {...preval, "image":false}});
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedImage(file); 
      setErrors((prev) => ({ ...prev, image: false })); 
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result); 
      };
      reader.readAsDataURL(file); 
    } else {
      toastr.warning("Please select a valid image file.")
      setErrors((prev) => ({ ...prev, image: "Please select a valid image file." }));
      setImage(null); 
    }
  };

  return (
    <div>
      <input type="file" accept="image/*" onChange={handleImageChange} />
      {image && <img src={image} height="100" width="150" alt="Selected" />}
    </div>
  );
};

export default ImageToDisplay;





